import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function PageTransition({ children }) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}

        /* Subtle entry from below */
        initial={{ opacity: 0, y: 8 }}

        /* Resting state */
        animate={{ opacity: 1, y: 0 }}

        /* Very soft exit */
        exit={{ opacity: 0, y: -4 }}

        transition={{
          duration: 0.18,
          ease: [0.4, 0, 0.2, 1], // Material-like easing
        }}

        style={{ height: "100%" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
